import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content h-auto"
}
const _hoisted_2 = { class: "bordered-card w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Documents Currently On File/Pending Admin Preview", -1)
const _hoisted_4 = { class: "small mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " No Business Associate Agreement documents have been uploaded for this local. ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "d-flex justify-content-end w-100" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DragDrop = _resolveComponent("DragDrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: _ctx.message,
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }, null, 8, ["message"]),
    _createVNode(_component_AlertsComponent, {
      error: _ctx.error,
      onReset: _cache[0] || (_cache[0] = () => _ctx.error = '')
    }, null, 8, ["error"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SelectComponent, {
            label: "Choose Document Type",
            selectedOption: _ctx.selectedDocType,
            "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDocType) = $event)),
            options: _ctx.docTypes,
            customClass: "full-width"
          }, null, 8, ["selectedOption", "options"]),
          _createVNode(_component_DragDrop, {
            customClasses: "grey large w-100",
            onUpdateFiles: _ctx.handleDrop,
            onStop: _ctx.preventFileUpload,
            onAllow: _ctx.allowFileUpload,
            key: "drag-drop-baa",
            reset: _ctx.reset,
            "onUpdate:reset": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reset) = $event)),
            loading: _ctx.loadingUpload
          }, null, 8, ["onUpdateFiles", "onStop", "onAllow", "reset", "loading"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              (_ctx.uploadedDocs.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedDocs, (document) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: document.DocumentID
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript;",
                            onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document?.DocumentID, FilePreview: document?.FilePreview, Type: 'dependent' })), ["prevent"])
                          }, _toDisplayString(document?.type_detail?.Description || document?.Description), 9, _hoisted_7)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(new Date(document.Date).toLocaleDateString()), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass({ 'text-danger': document.Status === 'Pending' })
                        }, _toDisplayString(document.Status), 3)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_8, _hoisted_10))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: _ctx.loading || _ctx.loadingUpload,
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFiles && _ctx.submitFiles(...args)), ["prevent"]))
            }, "Submit", 8, _hoisted_12)
          ])
        ]))
  ], 64))
}